import { useHistory } from 'react-router-dom';

import { useAuth } from 'Providers';

export function Logout(): null {
  const { logout } = useAuth();
  const history = useHistory();

  logout();
  history.replace('/');

  return null;
}
